module.exports = __webpack_public_path__ + "img/beyern-wheels-logo.e8a0e6e2.png";